module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6bkLK"))).then(() => module.bundle.root('fThBo'));